var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is.loaded)?_c('app-page',[_c('app-inner',{attrs:{"condensed":true}},[_c('app-text',[_c('app-group',{domProps:{"innerHTML":_vm._s(_vm.page.content)}}),_c('com-form')],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }